import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextIntroChip as Chip, TextIntroHeadline as Headline, StyledTextIntro, TextIntroText as Text } from './TextIntro.styles';
export const TextIntro = ({ children, chipProps, className, headline, headlineProps, isCenteredDesktop, isCenteredMobile, text, textProps })=>/*#__PURE__*/ _jsxs(StyledTextIntro, {
        $isCenteredDesktop: isCenteredDesktop,
        $isCenteredMobile: isCenteredMobile,
        className: className,
        children: [
            chipProps && /*#__PURE__*/ _jsx(Chip, {
                ...chipProps
            }),
            Boolean(headline) && /*#__PURE__*/ _jsx(Headline, {
                renderAs: "h2",
                ...headlineProps,
                children: headline
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                ...textProps,
                children: text
            }),
            children
        ]
    });

//# sourceMappingURL=TextIntro.js.map